module.exports = __webpack_public_path__ + "img/unlock-pro-backdrop-rings-prep.fa941b2e.png";